import React, { useState, useEffect } from "react";
import "../udi/outStockConfig.less";
import "@/static/style/margin.less";
import "@/static/style/init.less";
import "@/static/style/common.less";
import {
  Button,
  Table,
  message,
  Modal,
  Input,
  Select,
  Tooltip,
  Checkbox,
  Spin,
} from "antd";
import _, { get, filter } from "lodash";
import { getCookie, getParmUrl } from "@/public/utils";
import { EditOutlined } from "@ant-design/icons";
import moment from "moment";
import {
  operatorData,
  querySupplierProductListApi,
  updateSupplierProductCodeApi,
} from "./service";

var { Option } = Select;

const ProductCatalogDetail = (props) => {
  const [params, setParams] = useState({
    supplier_code: getCookie("supplier_code") || "",
    item_code: "",
    item_code_name: "", // 视客货品（编码或名称）本地过滤
    product_code_name: "", // 供应商货品（编码或名称）本地过滤
    is_no_product_relation: false, // 只筛选待绑定的
  });
  const [data, setData] = useState([]); // 后端返回的全量 product_list
  const [loading, setLoading] = useState(false);
  const [bindVisible, setBindVisible] = useState(false);
  const [modalParams, setModalParams] = useState({});

  // 供应商货品编码展示（前2个 + Tooltip 更多），未绑定时显示空
  // list 为 product_relation_list[]，取每项 third_product_code
  const getShow2AndMore = (list) => {
    var codes = (list || [])
      .map((r) => get(r, "third_product_code", ""))
      .filter(Boolean);
    if (codes.length === 0) {
      return "";
    }
    var before = _.slice(codes, 0, 2);
    var after = _.slice(codes, 2);
    return (
      <span>
        {before.map((item, index) => {
          return item + (index + 1 < get(before, "length") ? "," : "");
        })}
        {get(codes, "length") > 2 && (
          <Tooltip
            title={
              get(after, "length") &&
              after.map((item, index) => {
                return item + (index + 1 < get(after, "length") ? "," : "");
              })
            }
          >
            <a className="ml4">更多</a>
          </Tooltip>
        )}
      </span>
    );
  };

  // 打开绑定弹窗：直接克隆行，product_relation_list 原样保留，补 index/id 便于表格操作
  const changeEditModal = (record) => {
    var modalParams = _.cloneDeep(record);
    var relationList = get(modalParams, "product_relation_list", []) || [];
    relationList = relationList.map((item, index) => ({
      ...item,
      index,
      id: index,
    }));
    setModalParams({ ...modalParams, product_relation_list: relationList });
    setBindVisible(true);
  };

  // 弹窗内输入：改对应 index 项的 third_product_code
  const iptChangeTable = (record, e) => {
    setModalParams((prev) => {
      var relationList = _.cloneDeep(
        get(prev, "product_relation_list", []) || [],
      );
      relationList.map((item) => {
        if (item.index == get(record, "index")) {
          item.third_product_code = e.target.value;
        }
      });
      return { ...prev, product_relation_list: relationList };
    });
  };

  const deleteRow = (text) => {
    setModalParams((prev) => {
      var relationList = _.reject(
        get(prev, "product_relation_list", []) || [],
        ["id", text],
      );
      relationList = relationList.map((item, index) => ({
        ...item,
        index,
        id: index,
      }));
      return { ...prev, product_relation_list: relationList };
    });
  };

  const columns = [
    {
      title: "视客货品编码",
      key: "product_code",
      dataIndex: "product_code",
      align: "center",
    },
    {
      title: "视客货品名称",
      key: "product_name",
      dataIndex: "product_name",
      align: "center",
    },
    {
      title: "供应商货品编码",
      key: "supplier_product_code",
      dataIndex: "supplier_product_code",
      align: "center",
      render: (text, record) => {
        return (
          <span>
            {getShow2AndMore(get(record, "product_relation_list"))}
            <a className="ml10" onClick={() => changeEditModal(record)}>
              <EditOutlined />
            </a>
          </span>
        );
      },
    },
  ];

  const columnsModal = [
    {
      title: "序号",
      key: "index",
      dataIndex: "index",
      align: "center",
      render: (text) => {
        return <span>{text + 1}</span>;
      },
    },
    {
      title: "供应商货品编码",
      key: "third_product_code",
      dataIndex: "third_product_code",
      align: "center",
      width: 300,
      render: (text, record) => {
        return (
          <Input
            placeholder="请输入"
            className="width_250_input"
            onChange={(e) => iptChangeTable(record, e)}
            name="third_product_code"
            value={text}
          />
        );
      },
    },
    {
      title: "操作",
      key: "id",
      dataIndex: "id",
      align: "center",
      width: 80,
      render: (text, record) => {
        return <a onClick={() => deleteRow(text)}>删除</a>;
      },
    },
  ];

  const changeLoading = (loading) => {
    setLoading(loading);
  };

  // 查询：新接口接收 supplier_code + item_code_list，返回 data.product_list[]
  // product_list 每项含 product_code/product_name/item_code/item_name/supplier_code/supplier_name + product_relation_list[]
  const getTableData = async (paramArg) => {
    const cur = paramArg || params;
    changeLoading(true);
    try {
      const res = await querySupplierProductListApi({
        supplier_code: get(cur, "supplier_code"),
        item_code_list: [get(cur, "item_code")],
      });
      const productList = get(res, "data.data.product_list", []);
      setData(productList);
      // 同步当前 item_code 到 params（search 时保留输入值）
      setParams((prev) => ({ ...prev, ...cur }));
    } catch (err) {
      // ignore
    } finally {
      changeLoading(false);
    }
  };

  const init = () => {
    const itemCode = getParmUrl("item_code");
    const next = { ...params, item_code: itemCode };
    setParams(next);
    getTableData(next);
  };

  useEffect(() => {
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const search = () => {
    // 新接口不支持搜索字段，搜索为本地过滤；这里仅触发 params 同步（实际过滤在 displayData）
    setParams({ ...params });
  };

  const iptChangeModal = (e) => {
    setParams({ ...params, [e.target.name]: e.target.value.trim() });
  };

  const reloadSearch = () => {
    const next = {
      ...params,
      item_code_name: "",
      product_code_name: "",
      is_no_product_relation: false,
    };
    setParams(next);
  };

  const checkChange = (e) => {
    setParams({ ...params, is_no_product_relation: e.target.checked });
  };

  const add = () => {
    setModalParams((prev) => {
      var relationList = _.cloneDeep(
        get(prev, "product_relation_list", []) || [],
      );
      relationList.push({
        index: get(relationList, "length"),
        id: get(relationList, "length"),
        third_product_code: "",
      });
      return { ...prev, product_relation_list: relationList };
    });
  };

  const bindFunCheck = () => {
    var relationList = get(modalParams, "product_relation_list", []) || [];
    var flag = true;
    if (!get(relationList, "length")) {
      message.error("请输入货品编码");
      flag = false;
    }
    if (get(filter(relationList, ["third_product_code", ""]), "length")) {
      message.error("货品编码不能为空");
      flag = false;
    }
    return flag;
  };

  const handleCancel = () => {
    setBindVisible(false);
    setModalParams({});
  };

  // 提交：直接用 modalParams.product_relation_list，只保留后端需要的字段
  const bindFun = async () => {
    try {
      if (!bindFunCheck()) {
        return;
      }
      const relationList = get(modalParams, "product_relation_list", []) || [];
      const product_relation_list = relationList.map((item) => ({
        third_product_code: get(item, "third_product_code", ""),
        third_product_name: get(item, "third_product_name", ""),
        item_code: get(modalParams, "item_code"),
        supplier_code: get(params, "supplier_code"),
        product_code: get(modalParams, "product_code"),
      }));
      var submitParams = {
        ...operatorData,
        supplier_code: get(params, "supplier_code"),
        item_code: get(modalParams, "item_code"),
        product_list: [
          {
            product_code: get(modalParams, "product_code"),
            product_name: get(modalParams, "product_name"),
            item_code: get(modalParams, "item_code"),
            item_name: get(modalParams, "item_name"),
            supplier_code: get(modalParams, "supplier_code"),
            supplier_name: get(modalParams, "supplier_name"),
            product_relation_list,
          },
        ],
      };
      await updateSupplierProductCodeApi(submitParams);
      message.success("货品编码绑定成功！");
      handleCancel();
      getTableData();
    } catch (err) {
      console.log(err);
    }
  };

  // 本地过滤
  // 接口返回记录字段：product_code/product_name 为视客货品编码/名称，
  // 供应商货品编码在 product_relation_list[].third_product_code
  const getDisplayData = () => {
    const itemCodeName = (get(params, "item_code_name") || "").trim();
    const productCodeName = (get(params, "product_code_name") || "").trim();
    const onlyNoRelation = get(params, "is_no_product_relation");
    return data.filter((item) => {
      const itemCode = get(item, "product_code", "") || "";
      const itemName = get(item, "product_name", "") || "";
      const relationList = get(item, "product_relation_list", []) || [];
      const supplierCodes = relationList
        .map((r) => get(r, "third_product_code", ""))
        .filter(Boolean);
      if (itemCodeName) {
        const kw = itemCodeName.toLowerCase();
        if (
          !itemCode.toLowerCase().includes(kw) &&
          !itemName.toLowerCase().includes(kw)
        ) {
          return false;
        }
      }
      if (productCodeName) {
        // 供应商货品仅匹配 product_relation_list 里的 third_product_code
        const kw = productCodeName.toLowerCase();
        const matched = supplierCodes.some((c) =>
          (c || "").toLowerCase().includes(kw),
        );
        if (!matched) {
          return false;
        }
      }
      if (onlyNoRelation) {
        // 待绑定 = relation 列表为空（null/缺失/空数组）或所有 third_product_code 都为空
        if (supplierCodes.length > 0) {
          return false;
        }
      }
      return true;
    });
  };

  const displayData = getDisplayData();

  return (
    <div className="purchaseAdjustList outStockConfig">
      <section className="search mb20">
        <span className="ml12">视客货品：</span>
        <Input
          placeholder="请输入编码或名称"
          className="width_200_input"
          onChange={iptChangeModal}
          name="item_code_name"
          value={get(params, "item_code_name")}
        />
        <span className="ml12">供应商货品：</span>
        <Input
          placeholder="请输入"
          className="width_150_input mr16"
          onChange={iptChangeModal}
          name="product_code_name"
          value={get(params, "product_code_name")}
        />
        <span className="ml12"> </span>
        <Checkbox
          checked={get(params, "is_no_product_relation")}
          onChange={checkChange}
        >
          只筛选待绑定的
        </Checkbox>
        <div className="floatRight">
          <Button type="primary" className="ml16" onClick={search}>
            查询
          </Button>
          <Button className="ml16" onClick={reloadSearch}>
            重置
          </Button>
        </div>
      </section>
      <Spin spinning={loading}>
        <div style={{ overflow: "hidden", background: "#fff" }}>
          <Table
            columns={columns}
            dataSource={displayData}
            rowKey={(record, index) =>
              get(record, "product_code") + "_" + index
            }
          ></Table>
        </div>
      </Spin>
      <Modal
        title="绑定供应商货品编码"
        visible={bindVisible}
        width={800}
        onCancel={handleCancel}
        onOk={bindFun}
      >
        <Button className="ml16 mb16" onClick={add} type="primary">
          添加新编码
        </Button>
        <Table
          columns={columnsModal}
          dataSource={get(modalParams, "product_relation_list")}
          pagination={false}
          scroll={{ y: 400 }}
        ></Table>
      </Modal>
    </div>
  );
};

export default ProductCatalogDetail;



// WEBPACK FOOTER //
// ./src/pages/supplierGood/detail.jsx